
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_810_439)","stroke":"#7366EF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.708 8.708a2.292 2.292 0 104.584 0 2.292 2.292 0 00-4.584 0zM5.892 11.453l6.705-8.481M9.169 7.274L6.476 4.94M16.218 6.044l-7.64 9.147"}}),_c('path',{attrs:{"d":"M16.125 5.845c.433.831.655 1.754.65 2.69a6.657 6.657 0 01-.66 2.915A17.496 17.496 0 0114.2 14.2a20.257 20.257 0 00-1.934 2.732 9.905 9.905 0 00-.694 1.776c-.111.33-.254.542-.57.542-.289 0-.425-.125-.574-.544a9.71 9.71 0 00-.714-1.813 16.662 16.662 0 00-1.305-1.917c-.804-1.085-1.997-2.323-2.615-3.731a6.488 6.488 0 01-.57-2.72 5.707 5.707 0 011.354-3.717 5.73 5.73 0 014.41-2.058 5.924 5.924 0 011.758.26 5.734 5.734 0 013.379 2.835z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_810_439"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h22v22H0z"}})])])])
          )
        }
      }
    